export default __webpack_public_path__ + "static/media/liane.3d939bd4.png";